import React from 'react';
import classes from './MainImageSlider.module.css';
import Icon from '../Icons';
import Slider from 'rc-slider';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
// import required modules
import { Thumbs } from 'swiper/modules';
import hand3D from '../../Utils/images/handView-3d.png';
import { MainImageSliderProps } from '../../types';
import useMainImageSlider from './useMainImageSlider';
import Loader from '../Loader/Loader';
import LabDialog from '../LabDialog';

const MainImageSlider: React.FC<MainImageSliderProps> = (props) => {
  const {
    img,
    is360,
    viewSrc,
    iframeLoadActionCount,
    isLoading = false,
    isHandImage = false,
    isShowGIA = false,
    certification,
    certificationName,
    isHandLoaded
  } = props;

  const {
    islargeTab,
    thumbsContainerRef,
    allThumbnailRef,
    swipeSlider,
    getBackgroundColor,
    handleImageError,
    onColorSliderChange,
    handleThumbsResize,
    handleHandViewMobile,
    handleHandView,
    setHandleRange,
    handleRange,
    handleHandto3dView,
    sliderThumbImage,
    modules,
    onSliderChange,
    thumbsSwiper,
    setThumbsSwiper,
    setSwipeSlider
  } = useMainImageSlider(props);

  const {
    allThumbnailCoordinates,
    imageError,
    handView,
    colorState,
    handViewImage,
    activeIndex
  } = swipeSlider;

  return (
    <div className={`sliderWrapper`}>
      {isLoading ?
        <Loader /> :
        <>
          <Swiper
            loop={false}
            onResize={handleThumbsResize}
            pagination={{
              clickable: true,
              enabled: true
            }}
            navigation={{ prevEl: '.arrow-left', nextEl: '.arrow-right' }}
            thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
            modules={modules}
            className={`${classes.swiperMain} mainSlider`}
            onSlideChange={(swiper) => onSliderChange(swiper)}
          >
            {is360 && viewSrc ?
              <SwiperSlide>
                <div className={`${classes.iframe} sliderIframe ${handleRange ? 'disableFrame': ''}`}>
                  <>
                    {islargeTab && isHandImage &&
                      <div
                        className={`${classes.handViewMobiles} ${handView ? classes.handMobileToggle : classes.view3dMobileToggle}`}>
                        <button onClick={handleHandViewMobile}>
                          {!handView ?
                            <>
                              <img
                                className={classes.viewHandimg}
                                src={hand3D}
                                alt={'Change view'}
                              />
                              <span className={'text-padding-top-15'}>Hand View</span>
                            </>
                            : <>
                              <Icon name={'hk-rotate'} />
                              <span className={'text-padding-top-15'}>360<sup>o</sup> View</span>
                            </>
                          }
                        </button>
                      </div>
                    }
                    <iframe src={viewSrc} className={`${classes.viewIframe} ${certificationName}`} scrolling={'no'} />
                    {isHandImage ? <span className={classes.frameText}>
                      Interactive Video – Drag to Rotate
                      <Icon name={'hk-hand'} />
                    </span> : null}
                  </>
                  {iframeLoadActionCount && iframeLoadActionCount > 0 ? <Loader ajaxLoad={true} /> : null}
                </div>
              </SwiperSlide>
              : null
            }
            {img.length > 0 ?
              img.map((imgPath: string, index: number) => {
                return (
                  <div key={index} className={classes.mainImages}>
                    {
                      !imageError[index] ?
                        <SwiperSlide key={index}>
                          {
                            index === img.length - 1 && isHandImage ?
                              <>
                                <img src={imgPath}
                                     className={classes.lightSkin} style={{ opacity: `calc(100% - ${colorState}%)` }} />
                                <img src={imgPath?.replaceAll('/V5/2000', '/V6/2000')?.replaceAll('V52000', 'V62000')}
                                     className={classes.darkSkin} />
                              </>
                              :
                              <img src={`${imgPath}?img=${index}`} />
                          }
                        </SwiperSlide>
                        : null
                    }
                  </div>
                );
              })
              : null
            }
            <div className={`${classes.buttonNav} ${!islargeTab ? classes.disableButtons : ''}`}>
              <button className="arrow-left arrow">
                <Icon name={'hk-chevron-left_M'} />
              </button>
              <button className="arrow-right arrow">
                <Icon name={'hk-chevron-right_M'} />
              </button>
            </div>
          </Swiper>
          <Swiper
            onSwiper={setThumbsSwiper}
            loop={false}
            spaceBetween={10}
            slidesPerView={7}
            freeMode={false}
            observer={true}
            centeredSlides={false}
            observeParents={true}
            watchSlidesProgress={true}
            modules={[Thumbs]}
            ref={allThumbnailRef}
            className={`${classes.swiperThumb} swiperThumb ${islargeTab ? '!hidden' : ''} ${isShowGIA && !!certification ? classes.certificateWithThumb : ''}`}
            // classes.disableThumbs
            breakpoints={{
              0: {
                direction: 'horizontal'
              },
              1440: {
                direction: 'vertical'
              }
            }}
          >
            {
              is360 && viewSrc && sliderThumbImage.length > 0 ?
                <SwiperSlide className={`${isHandImage ? classes.swiper3d : ''}`}>
                  <div className={`${classes.icon360} ${activeIndex === 0 && !handView ? classes.active3dView : ''}`}
                       onClick={handleHandto3dView}>
                    <div className={classes.icon360Group}><Icon name="hk-rotate" /><span
                      className={classes.text360Side}>360<sup>o</sup></span>
                    </div>
                    <span className={classes.text360}>Experience</span>
                  </div>
                  {isHandImage && <div
                    className={`${classes.icon360Hand} ${handView ? classes.activeHand : ''} ${activeIndex === 0 ? classes.actives : ''}`}
                    onClick={handleHandView}>
                    <img
                      src={sliderThumbImage[0].replaceAll('/V1/150', '/V5/150').replaceAll('V1150', 'V5150')}
                      alt={'Hand View'} />
                  </div>
                  }
                </SwiperSlide> : null
            }
            {sliderThumbImage.length > 0 ? sliderThumbImage.map((imgPath: string, index: number) => {
              return (
                <div
                  key={index}
                  className={classes.sliderThumbImages}
                >
                  {
                    !imageError[index] ?
                      <SwiperSlide
                        key={index}
                        //@ts-ignore
                        ref={thumbsContainerRef}
                        className={!is360 && activeIndex === index ? 'swiper-slide-thumb-active' : ''}
                        onClick={() => {
                          if (index === sliderThumbImage.length - 1) {
                            setSwipeSlider((prevState) => {
                              return {
                                ...prevState,
                                handViewImage: true
                              };
                            });
                          }
                        }}
                      >
                        <img
                          src={`${imgPath}?img=${index}`}
                          alt={`Thumb Image-${index}`}
                          className={imageError[index] ? `${classes.imgNotFound}` : ''}
                          onError={() => handleImageError(index)}
                        />
                        <span className={imageError[index] ? `${classes.notFound}` : ''} />
                      </SwiperSlide> : null
                  }
                </div>
              );
            }) : null}
          </Swiper>
        </>
      }
      {isShowGIA && !!certification && !!certificationName ?
        <LabDialog
          certificationName={certificationName}
          allThumbnailCoordinates={allThumbnailCoordinates}
          certification={certification}
        /> :
        null}
      {isHandImage ? <div
        className={`${(handView && isHandLoaded && activeIndex === 0) ? classes.displayBlock : classes.displayHidden} ${classes.rangeSlider}`}
        style={{ '--handleBackground': getBackgroundColor } as { [key: string]: string }}
      >
        <Slider
          vertical
          onChange={()=> setHandleRange(true)}
          onChangeComplete={onColorSliderChange}
          min={0}
          max={100}
          defaultValue={0}
        />
      </div> : null}
    </div>
  );
};

export default MainImageSlider;
